import MessageBox from "element-ui/lib/message-box";
import { browserIsZoom } from './util';
var UrlHelper = (function () {
    function UrlHelper() {
    }
    UrlHelper.getQueryString = function (url, name) {
        var index = url.indexOf("?");
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var hax = url.indexOf("#");
        var tempUrl = url.substring(index + 1, hax > -1 ? hax : url.length);
        var r = tempUrl.match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    };
    UrlHelper.getParams = function (url) {
        var index = url.indexOf("?");
        var hax = url.indexOf("#");
        var tempUrl = url.substring(index, hax > -1 ? hax : url.length);
        var theRequest = new Object();
        if (tempUrl.indexOf("?") != -1) {
            var str = tempUrl.substr(1), strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    };
    UrlHelper.decode = function (url) {
        return decodeURI(url);
    };
    UrlHelper.encode = function (url) {
        return encodeURI(url);
    };
    UrlHelper.addParam = function (url, paramKey, paramVal) {
        var andStr = "?";
        var beforeparam = url.indexOf("?");
        if (beforeparam != -1) {
            andStr = "&";
        }
        return url + andStr + paramKey + "=" + encodeURIComponent(paramVal);
    };
    UrlHelper.windowOpenIntercept = function (url) {
        var urlISPrint = url.indexOf('/print2.html') > -1 || url.indexOf('/print.html') > -1 || url.indexOf('printbatch.html') > -1;
        if (urlISPrint && browserIsZoom()) {
            MessageBox.confirm('您已使用了浏览器的缩放功能，可能会影响最终的打印效果，建议修改成正常分辨率。请确认是否继续？', '提示', {
                customClass: 'confirm'
            }).then(function (res) {
                if (res) {
                    window.open(url);
                }
            }).catch(function () {
            });
        }
        else {
            window.open(url);
        }
    };
    return UrlHelper;
}());
export { UrlHelper };
var UrlWrapper = (function () {
    function UrlWrapper() {
    }
    UrlWrapper.prototype.addDc = function (url) {
        if (!url) {
            throw new Error("地址非法，请重试");
        }
        return UrlHelper.addParam(url, "_dc", new Date().getTime());
    };
    return UrlWrapper;
}());
export { UrlWrapper };
